import { createTheme } from "@mui/material"

import { auth, getToken } from "./auth"

//Generate the partner key for the current user

//We will try to use the partner key from the claim if it exists, but we fallback
const partnerKey = async () => {
  const user = auth.currentUser
  const token = await getToken()
  let key = user.uid
  if (token?.claims?.partner) {
    key = token.claims.partner
  }
  return key
}

//Create the MUI theme
const theme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#15151f",
      secondary: {
        color: "#202030"
      }
    },
    primary: {
      main: "#5af0be"
    },
    text: {
      primary: "#ffffff"
    }
  },
  typography: {
    fontFamily: "Muli,sans-serif",
    fontWeightLight: 300,
    fontWeightMedium: 700,
    fontWeightRegular: 500,
    fontWeightBold: 900,
    h5: {
      fontFamily: "Nunito,sans-serif",
      fontWeight: 700
    }
  },

  //I was and still am having issues with the autofill background color
  components: {
    MuiCssBaseline: {
      styleOverrides: `
          input:-webkit-autofill,
          input:-webkit-autofill:hover, 
          input:-webkit-autofill:focus, 
          input:-webkit-autofill:active  {
            -webkit-box-shadow: 0 0 0 100px #202030 inset !important;
          }
        `
    },
    MuiPaper: {
      defaultProps: {
        elevation: 4
      },
      styleOverrides: {
        root: {
          borderRadius: 5,
          elevation: 32
        }
      }
    },
    MuiAppBar: {
      defaultProps: {
        elevation: 0
      },
      styleOverrides: {
        root: {
          borderRadius: 0
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 5
        }
      }
    }
  }
})

export { partnerKey, theme }
